export default {
  title: 'Pöydät',
  count_one: '{{count}} pöytä',
  count_other: '{{count}} pöytää',
  filtered_count: '{{shown}} / {{count}} pöydästä',
  intro:
    'Jokaisella pöydällä on oma linkkinsä ja QR-koodinsa. Sen skannaavat vieraat tilaavat kyseiseen pöytään, ja näet pöydän jokaisessa tilauksessa.',
  migrated: {
    title: 'Huone-/pöytäpalvelu on nyt Pöytätilaus',
    description:
      'Lisäsimme jokaiselle toimipaikallesi pöydän, joka on nimetty sen mukaan, jotta vieraat voivat jatkaa tilaamista. Nimeä ne vastaamaan pöytiäsi tai lisää uusia.',
  },
  add: {
    label: 'Lisää pöytä',
    placeholder: 'esim. 7, 1A tai Terassi 2',
    button: 'Lisää pöytä',
  },
  errors: {
    empty: 'Anna pöydän nimi.',
    duplicate: 'Pöytä nimeltä “{{name}}” on jo olemassa.',
    too_long: 'Pöydän nimessä voi olla enintään {{max}} merkkiä.',
  },
  columns: {
    order: 'Järjestys',
    table: 'Pöytä ja linkki',
    on: 'Päällä',
    copy: 'Kopioi linkki',
    qr: 'QR-koodi',
    actions: 'Toiminnot',
  },
  switch: {
    on: 'Päällä',
    off: 'Pois',
  },
  buttons: {
    copy: 'Kopioi linkki',
    copied: 'Kopioitu',
    download_qr: 'Lataa QR-koodi',
    qr_short: 'QR-koodi',
    rename: 'Nimeä uudelleen',
    delete: 'Poista',
    save: 'Tallenna',
    cancel: 'Peruuta',
  },
  aria: {
    move: 'Siirrä {{name}} (nuolinäppäimet)',
    switch: '{{name}} päällä',
    copy: 'Kopioi linkki: {{name}}',
    copied: 'Linkki kopioitu',
    download_qr: 'Lataa QR-koodi: {{name}}',
    rename: 'Nimeä uudelleen: {{name}}',
    delete: 'Poista {{name}}',
    more: 'Lisää kohteelle {{name}}',
    new_name: 'Uusi nimi: {{name}}',
  },
  tooltips: {
    move: 'Järjestä vetämällä',
    move_disabled: 'Tyhjennä haku järjestääksesi',
  },
  rename_hint: 'Linkki ja QR-koodi pysyvät samoina.',
  no_link: 'Kauppaosoitetta ei vielä ole',
  search: {
    placeholder: 'Hae pöytiä',
    no_results: 'Pöytää nimeltä “{{text}}” ei löydy.',
  },
  load_failed: {
    title: 'Pöytien lataaminen epäonnistui.',
    retry: 'Yritä uudelleen',
  },
  empty: {
    title: 'Ei vielä pöytiä',
    text: 'Lisää pöytäsi yllä, niin saat jokaiselle linkin ja QR-koodin. Vieraat eivät voi tilata pöytään, ennen kuin lisäät sellaisen.',
  },
  delete: {
    title: 'Poistetaanko pöytä “{{name}}”?',
    warning:
      'Tämän pöydän tulostetut QR-koodit lakkaavat toimimasta. Sen skannaavia vieraita pyydetään kääntymään henkilökunnan puoleen.',
    softer: 'Jos haluat estää tämän pöydän tilaukset joksikin aikaa, kytke se mieluummin pois päältä.',
    confirm: 'Poista pöytä',
    cancel: 'Peruuta',
  },
  announcements: {
    moved: '“{{name}}” siirretty paikalle {{position}} / {{count}}.',
    instructions: 'Siirrä pöytää kohdistamalla sen kahva ja painamalla ylä- tai alanuolinäppäintä.',
  },
  qr_image: {
    table: 'Pöytä',
  },
  toasts: {
    added: 'Pöytä “{{name}}” lisätty',
    renamed: '“{{old}}” nimetty uudelleen: “{{name}}”',
    deleted: 'Pöytä “{{name}}” poistettu',
    switched_on: '“{{name}}” kytketty päälle',
    switched_off: '“{{name}}” kytketty pois päältä',
    failed_to_save: 'Tallennus epäonnistui. Yritä uudelleen.',
    failed_to_reorder: 'Uutta järjestystä ei tallennettu. Yritä uudelleen.',
    failed_to_download_qr: 'QR-koodia ei voitu tallentaa. Yritä uudelleen.',
    copy_failed: 'Linkkiä ei voitu kopioida. Yritä uudelleen.',
  },
};
